import React from 'react'
import * as FooterStyles from './Footer.module.scss'
import Social from '../Social/Social'
import Hr from '../Hr/Hr'
import { Link } from 'gatsby'
import Logomark from '../Logomark/Logomark'

const Footer = () => {
  const currentYear = new Date()

  return (
    <>
      <footer>
        <div className={FooterStyles.Wrapper}>
          <Logomark />
          <div className={FooterStyles.Cols}>
            <div className={FooterStyles.Col}>
              <h4>Follow Us</h4>
              <Social />
            </div>
            <div className={FooterStyles.Col}>
              <h4>About Us</h4>
              <p>
                Don&apos;t already know how splendiferous we are?{` `}
                <strong>
                  <Link to={`/about`}>Read the Muddy Stilettos story</Link>
                </strong>
                {` `}.
              </p>
            </div>
            <div className={FooterStyles.Col}>
              <h4>Work With Us</h4>
              <p>
                We love to connect with like-minded brands and clients. If
                you’re interested in working with us
                {` `}
                <strong>
                  <a href={`https://muddystilettos.co.uk/work-with-us`}>
                    click here for national and regional contacts.
                  </a>
                  {` `}
                </strong>
              </p>
            </div>
            <div className={FooterStyles.Col}>
              <h4>Contact Us</h4>
              <p>
                Whether you want to leave your feedback, ask a question or need
                help -{' '}
                <strong>
                  <a href="https://muddystilettos.co.uk/contact/">
                    click here to get in touch with us
                  </a>
                </strong>
                .
              </p>
            </div>
          </div>
          <Hr />
          <div className={FooterStyles.Copyright}>
            <p>
              <a
                href={`https://muddystilettos.co.uk/competitions-offers-terms-conditions`}
              >
                Reader Treats Terms &amp; Conditions
              </a>
              <br />
              Read our{` `}
              <a href={`https://muddystilettos.co.uk/privacy-policy`}>
                Privacy Policy
              </a>
              {` `}
              and{` `}
              <a href={`https://muddystilettos.co.uk/terms-conditions`}>
                Terms &amp; Conditions
              </a>
              {` `}
              here.
            </p>
            <p>
              Copyright © {currentYear.getFullYear()} Muddy Stilettos. All
              images © of their respective owners.
            </p>
          </div>
        </div>
      </footer>
      <script
        type="text/javascript"
        src="https://s.skimresources.com/js/122679X1583220.skimlinks.js"
      />
    </>
  )
}

export default Footer
